import React from "react";
import Panel from "../panel/Panel";
import Form from "./forms/New";
import { CrownOutlined } from '@ant-design/icons';

export default () => <Panel title={<span><CrownOutlined /> Kunde anlegen</span>} id="customers::new">
    <Form/>
</Panel>;

